module.exports = __webpack_public_path__ + "static/media/helpcard_repair.733bc489.svg";